export var RenameType;
(function (RenameType) {
    RenameType["MODEL"] = "model";
    RenameType["FIELD"] = "field";
})(RenameType || (RenameType = {}));
//# sourceMappingURL=rename.js.map